import { Injectable }                 from '@angular/core';
import { FccInstallationTypeEnum }    from '@app/modules/fcc/models/fcc.model';
import { FccInstallationTypeEnumDTO } from '@openApiGenerated/management-api';
import { LoggerService }              from '@shared/services/logger.service';

@Injectable( {
	providedIn: 'root'
} )
export class FccMapperService {

	constructor(
		private _logger: LoggerService
	) {}

	get fcc() {
		return {
			installationTypeDtoToTmo: this.mapInstallationTypeDtoToTmo.bind( this ) as typeof this.mapInstallationTypeDtoToTmo,
			installationTypeTmoToDto: this.mapInstallationTypeTmoToDto.bind( this ) as typeof this.mapInstallationTypeTmoToDto
		};
	}

	private mapInstallationTypeDtoToTmo( fccInstallationType: FccInstallationTypeEnumDTO ): FccInstallationTypeEnum {

		switch ( fccInstallationType ) {
			case FccInstallationTypeEnumDTO.FCC_DATA_CENTER:
				return FccInstallationTypeEnum.FCC_DATACENTER;

			case FccInstallationTypeEnumDTO.LOCAL:
				return FccInstallationTypeEnum.LOCAL;

			default:
				this._logger.warn( `mapInstallationTypDtoToTmo has no case for TMO ${ fccInstallationType }` );
				return null;
		}
	}

	private mapInstallationTypeTmoToDto( fccInstallationType: FccInstallationTypeEnum ): FccInstallationTypeEnumDTO {

		switch ( fccInstallationType ) {
			case FccInstallationTypeEnum.FCC_DATACENTER:
				return FccInstallationTypeEnumDTO.FCC_DATA_CENTER;

			case FccInstallationTypeEnum.LOCAL:
				return FccInstallationTypeEnumDTO.LOCAL;

			default:
				this._logger.warn( `mapInstallationTypTmoToDto has no case for DTO ${ fccInstallationType }` );
				return null;
		}
	}
}
